import { __awaiter } from "tslib";
/* eslint-disable-next-line */
import { SLOW_DATA_STALE_TIME_MSEC } from '../../../constants';
import { getDefaultHeaders, useAcquireToken, useAppConfig, useAuth, } from '@msrceng/auth';
import { InteractionStatus } from '@azure/msal-browser';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useMsal } from '@azure/msal-react';
import { gqlrequest } from '../../graphql';
import { isLatestUserInterfaceEnabledGql, setIsLatestUserInterfaceEnabledGql, } from '../../graphql/authzgql';
export const QUERY_KEY_NEW_EXPERIENCE_STATE = 'newExperienceState';
/**
 * GraphQL API that requests the current state of the new experience toggle.
 */
export const useNewExperienceStateApi = (userInterface) => {
    const { apiRoot } = useAppConfig();
    const { isApiTokenLoaded } = useAuth();
    const { inProgress } = useMsal();
    const acquireTokenSilent = useAcquireToken();
    return useQuery([QUERY_KEY_NEW_EXPERIENCE_STATE, userInterface], () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const token = (inProgress !== InteractionStatus.Startup &&
            ((_a = (yield acquireTokenSilent())) === null || _a === void 0 ? void 0 : _a.accessToken)) ||
            undefined;
        const defaultHeaders = getDefaultHeaders(token);
        return yield gqlrequest(apiRoot + '/authzgraphql', isLatestUserInterfaceEnabledGql, defaultHeaders, {
            userInterface,
        }).then(data => data.isLatestUserInterfaceEnabled);
    }), {
        retry: false,
        keepPreviousData: false,
        cacheTime: SLOW_DATA_STALE_TIME_MSEC,
        staleTime: SLOW_DATA_STALE_TIME_MSEC,
        refetchOnWindowFocus: false,
        enabled: isApiTokenLoaded,
    });
};
/**
 * GraphQL API that updates the user's "use new experience" settings.
 */
export const useNewExperienceMutationApi = (userInterface) => {
    const { apiRoot } = useAppConfig();
    const { inProgress } = useMsal();
    const acquireTokenSilent = useAcquireToken();
    const queryClient = useQueryClient();
    return useMutation([QUERY_KEY_NEW_EXPERIENCE_STATE, userInterface], (enable) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const token = (inProgress !== InteractionStatus.Startup &&
            ((_a = (yield acquireTokenSilent())) === null || _a === void 0 ? void 0 : _a.accessToken)) ||
            undefined;
        const headers = getDefaultHeaders(token);
        const userSettings = {
            enable,
            userInterface,
        };
        return gqlrequest(apiRoot + '/authzgraphql', setIsLatestUserInterfaceEnabledGql, headers, userSettings);
    }), {
        onSuccess: () => {
            queryClient.invalidateQueries([QUERY_KEY_NEW_EXPERIENCE_STATE]);
        },
    });
};
